
import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import './PoliciesProcedures.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

const ProceduresPage = () => {
    const [procedures, setProcedures] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);

    useEffect(() => {
        if (selectedId) {
            setPdfLoading(true);
            // Google Docs Viewer often doesn't fire onLoad reliably due to cross-origin.
            // visual timeout is better than infinite loading.
            const timer = setTimeout(() => setPdfLoading(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [selectedId]);

    useEffect(() => {
        const fetchProcedures = async () => {
            try {
                const snapshot = await firestore.collection('procedures').get();
                const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                list.sort((a, b) => {
                    const titleA = a.title || "";
                    const titleB = b.title || "";
                    return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
                });
                setProcedures(list);
            } catch (error) {
                console.error("Error fetching procedures:", error);
            }
            setLoading(false);
        };
        fetchProcedures();
    }, []);

    const selectedProcedure = procedures.find(p => p.id === selectedId);

    return (
        <div className="pp-page-wrapper">
            <div className="pp-container">
                <h1 className="pp-title">Standard Operating Procedures</h1>

                <div className="procedures-layout">
                    <div className="procedures-sidebar">
                        <h3>Categories</h3>
                        {loading ? <p>Loading...</p> : (
                            procedures.length === 0 ? <p>No procedures found.</p> :
                                procedures.map((proc) => (
                                    <div
                                        key={proc.id}
                                        className={`sidebar-item ${selectedId === proc.id ? 'active' : ''}`}
                                        onClick={() => setSelectedId(proc.id)}
                                    >
                                        {proc.title || proc.id}
                                    </div>
                                ))
                        )}
                    </div>

                    <div className="procedure-details">
                        {selectedProcedure ? (
                            <>
                                <h2>{selectedProcedure.title}</h2>
                                {selectedProcedure.content && (
                                    <div className="procedure-text">
                                        {selectedProcedure.content}
                                    </div>
                                )}

                                {selectedProcedure.file && (selectedProcedure.file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/) || selectedProcedure.file.name.toLowerCase().endsWith('.pdf')) && (
                                    <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                                        <h4 style={{ marginBottom: '15px', color: '#e2e8f0' }}>Attached Document</h4>

                                        {/* Preview Section */}
                                        <div style={{ marginBottom: '15px' }}>
                                            {selectedProcedure.file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/) ? (
                                                <img
                                                    src={selectedProcedure.file.url}
                                                    alt="Procedure Attachment"
                                                    style={{ maxWidth: '100%', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                                                />
                                            ) : selectedProcedure.file.name.toLowerCase().endsWith('.pdf') ? (
                                                <div className="pdf-container">
                                                    {pdfLoading && <div className="pdf-loading">Loading document...</div>}
                                                    <div className="pdf-wrapper">
                                                        <div className="pdf-restriction-overlay" title="Download disabled"></div>
                                                        <iframe
                                                            key={selectedProcedure.file.url}
                                                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedProcedure.file.url)}&embedded=true`}
                                                            title="PDF Preview"
                                                            className="pdf-iframe"
                                                            width="100%"
                                                            height="100%"
                                                        >
                                                            <p>Your browser does not support PDFs.</p>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>

                                        {/* Download disabled */}
                                    </div>
                                )}


                            </>
                        ) : (
                            <div className="no-selection">
                                {loading ? "Loading..." : "Please select a procedure from the sidebar to view details."}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProceduresPage;
